import React, { Component } from "react";
import { connect } from "react-redux";
import "react-datetime/css/react-datetime.css";
import CustomScroll from "react-custom-scroll";

import Preloader from "../../../Preloader";
import ClientService from "../../../../services/Initialization/ClientService";
import { Form } from "./Form";

class ClientOrder extends Component {
  state = {
    sendForm: false,
    isLoading: false,
    noData: false,
  };

  componentDidMount() {
    const { UserProfile } = this.props;
    const systemDetail = {
      name: `${UserProfile.firstName} ${UserProfile.surname}`,
      email: UserProfile.email,
      department: UserProfile.department ? UserProfile.department : "",
    };
    this.setState({ isLoading: true });
    ClientService.getTRClientDetails({ customerId: 0 }).then((res) => {
      //let trClientDetailsJson = JSON.parse(res);

      systemDetail.company = res.name;
      systemDetail.phone = res.phone;

      this.setState({ systemDetail });

      if (!res.clientAccountCode) {
        this.setState({ noData: true });
      }

      this.setState({ isLoading: false });
    });
  }
  render() {
    const { _ } = this.props;
    const { systemDetail } = this.state;
    return (
      <>
        <h2 className="ml-3"> {_.ClientForms.ClientOrder.Title}</h2>
        {this.state.isLoading && <Preloader />}
        <CustomScroll
          heightRelativeToParent={"calc(100% - 50px)"}
          allowOuterScroll={true}
        >
          {this.state.noData ? (
            <div className="d-flex report-sent-message">
              <h6>This client does not have any details to amend.</h6>
            </div>
          ) : (
            systemDetail && (
              <Form
                _={_}
                SystemDetail={this.state.systemDetail}
                sendForm={(payload) => {
                  this.setState(payload);
                }}
              ></Form>
            )
          )}
        </CustomScroll>
      </>
    );
  }
}

export const mapStateToProps = ({ _ }) => ({ _ });
export default connect(mapStateToProps)(ClientOrder);
